












































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
import GJgrowEventCreateFormFormat from '../GJgrowEventCreateFormFormat.vue';
import { GEnum } from '@/constants/enum.defination';
import { masterModule } from '@/store/modules/entities/master.module';
import { Competency, CompetencySettingType, SettingType } from '@/models/competency/competency';
import GJgrowEventCreateSelection from './GJgrowEventCreateQuestionSettingCompetencySelection.vue';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import GJgrowEventCreateDetailSetting from '@/views/GJgrowEventCreate/QuestionSetting/GJgrowEventCreateQuestionSettingDetail.vue';
import { examCreateModule } from '@/store/modules/frames/exam-create.module';
import { EventParam } from '@/models/jgrow/event-param';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity } from '@/models/activity/activity';
import { required } from 'vuelidate/lib/validators';
import { Trend } from '@/models/trend/trend';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { JgrowEventLikertScale } from '@/models/jgrow/jgrow-event-likert-scale';
import { JgrowEventLikertScaleItem } from '@/models/jgrow/jgrow-event-likert-scale-item';

@Component({
  name: 'GJgrowEventCreateQuestionSetting',
  components: { GVTag, GJgrowEventCreateDetailSetting, GJgrowEventCreateSelection, GJgrowEventCreateFormFormat },
  computed: {},
  methods: {},
  validations: {
    evalSettingDetail: {
      trendIDs: { required },
    },
  },
})
export default class GJgrowEventCreateQuestionSetting extends Mixins(GPageBase) {
  competencySettingType: GEnum.CompetencySettingType = GEnum.CompetencySettingType.Full;
  freeWordSkillRequiredRadio: GEnum.RadioLabel = GEnum.RadioLabel.False;
  iatRequired: boolean = true;
  selfEvalRequired: boolean = true;
  giftRequired: boolean = true;
  isProgressNotification: boolean = true;
  requiredRespondents: number = 3;
  listColumn: object[] = [];
  searchName: string = '';
  searchItem: string = '';

  async mounted() {
    //設問設定画面到達フラグをセット
    jgrowEventCreateModule.setVisitQuestionSettingView(true);
    this.createColumn();
  }

  doActivitySearchName() {
    this.searchItem = '';
    jgrowEventCreateModule.doActivitySearchName(this.searchName);
  }

  doActivitySearchItem() {
    this.searchName = '';
    jgrowEventCreateModule.doActivitySearchItem(this.searchItem);
  }

  choiceActivity(act: Activity) {
    jgrowEventCreateModule.choiceActivity(act);
  }

  discardActivity(act: Activity) {
    jgrowEventCreateModule.discardActivity(act);
  }

  get activities() {
    return activityModule.activities;
  }

  get selectionActivities() {
    return jgrowEventCreateModule.selectionActivities;
  }

  get selectActivities() {
    return jgrowEventCreateModule.selectActivities;
  }

  get selectedActivities() {
    return jgrowEventCreateModule.selectedActivities;
  }

  get selectedActivityIds() {
    return jgrowEventCreateModule.selectedActivities.map((act: Activity) => act.activityID);
  }

  get competencySettingTypeBasic(): GEnum.JgrowCompetencySettingType {
    return GEnum.JgrowCompetencySettingType.Basic;
  }
  get competencySettingTypeCustom(): GEnum.JgrowCompetencySettingType {
    return GEnum.JgrowCompetencySettingType.Custom;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get eventParam(): EventParam {
    return jgrowEventCreateModule.params;
  }

  get q1Disable(): boolean {
    return !this.eventParam.q1Enable;
  }

  get isQ1Invalid(): boolean {
    return this.eventParam.q1Enable && (this.eventParam.q1 == null || this.eventParam.q1 == '' || this.eventParam.q1 == undefined);
  }

  get q2Disable(): boolean {
    return !this.eventParam.q2Enable;
  }

  get isQ2Invalid(): boolean {
    return this.eventParam.q2Enable && (this.eventParam.q2 == null || this.eventParam.q2 == '' || this.eventParam.q2 == undefined);
  }

  get q3Disable(): boolean {
    return !this.eventParam.q3Enable;
  }

  get isQ3Invalid(): boolean {
    return this.eventParam.q3Enable && (this.eventParam.q3 == null || this.eventParam.q3 == '' || this.eventParam.q3 == undefined);
  }

  get isValid(): boolean {
    // アクティビティが2つは選択されていること
    // 追加設問：チェックされ、文字が入力されていること（チェック + 空は許容しない）
    const likertResult = jgrowEventCreateModule.params.validationLikertScales();
    return this.selectedActivities.length > 0 && !this.isQ1Invalid && !this.isQ2Invalid && !this.isQ3Invalid && likertResult;
  }

  get likertScale(): JgrowEventLikertScale[] {
    return this.eventParam.likertScale;
  }

  rowDisableColor(row: Activity): string {
    if (row.companyID === null) {
      return 'invalid-row';
    }
    return 'no-setting-row';
  }

  handleChangeCompetencySettingType(value: GEnum.CompetencySettingType) {
    switch (value) {
      case GEnum.CompetencySettingType.Full:
        examCreateModule.setCompetencySelections(masterModule.competencies);
        break;
      case GEnum.CompetencySettingType.Recommend:
        examCreateModule.setCompetencySelections(masterModule.competencySettingType.recommendCompetencies.map((competency: SettingType) => masterModule.toCompetency(competency.competencyID)));
        break;
      case GEnum.CompetencySettingType.Mini:
        examCreateModule.setCompetencySelections(masterModule.competencySettingType.miniCompetencies.map((competency: SettingType) => masterModule.toCompetency(competency.competencyID)));
        break;
      case GEnum.CompetencySettingType.Customize:
        examCreateModule.cleanCompetencySelections();
        break;
    }
  }

  // リッカート尺度の設問追加
  handleAddLikertScale() {
    jgrowEventCreateModule.addLikertScale();
  }

  handleDeleteLikertScale(i: number) {
    jgrowEventCreateModule.deleteLikertScale(i);
  }

  // リッカート尺度の設問に対する選択肢の追加（最大7）
  handleAddLikertScaleItems(ls: JgrowEventLikertScale) {
    if (ls.items.length < 7) {
      const orderIsValue = ls.items.length + 1;
      const jgelsi = new JgrowEventLikertScaleItem();
      jgelsi.value = orderIsValue;
      ls.items.push(jgelsi);
    }
  }

  filterPrimarySchoolTrends(trendID: number): boolean {
    const PrimarySchoolTrend = [GEnum.TrendCheck.SelfLikingP, GEnum.TrendCheck.ComfortLevelP, GEnum.TrendCheck.ToughnessP, GEnum.TrendCheck.SelfLikingPLower, GEnum.TrendCheck.ComfortLevelPLower, GEnum.TrendCheck.ToughnessPLower];
    return PrimarySchoolTrend.includes(trendID);
  }

  convertToCompetencyTooltip(content: SettingType[]): string {
    return !content ? '' : content.map(d => d.name).join(' | ');
  }

  get trends(): Trend[] {
    return masterModule.trends;
  }

  createColumn(): void {
    //this.listColumn = [this.columnCustomCompetencyName, this.columnCompetencies, this.columnActivitySelect];
    this.listColumn = [this.columnCustomCompetencyName, this.columnCompetencies,];
  }
  get columnCustomCompetencyName(): any {
    return {
      title: 'アクティビティ名',
      key: 'activityName',
      width: 320,
    };
  }

  get columnCompetencies(): any {
    return {
      title: 'アイテム',
      slot: 'selected-item',
    };
  }
}
